unit assets.settings.budgetsownfleet;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Buttons,
  Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCTypes, VCL.TMSFNCUtils,
  VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCGridCell,
  VCL.TMSFNCGridOptions, VCL.TMSFNCCustomComponent, VCL.TMSFNCCustomGrid,
  VCL.TMSFNCGridDatabaseAdapter, VCL.TMSFNCCustomControl,
  VCL.TMSFNCCustomScrollControl, VCL.TMSFNCGridData, VCL.TMSFNCGrid, Data.DB,
  WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Client;

type
  TfrmBudgetsOwnFleet = class(TForm)
    scTop: TScrollBox;
    sbBottom: TScrollBox;
    WebLabel1: TLabel;
    btnInsert: TSpeedButton;
    btnEdit: TSpeedButton;
    btnDelete: TSpeedButton;
    btnClose: TSpeedButton;
    gBudget: TTMSFNCGrid;
    daBudget: TTMSFNCGridDatabaseAdapter;
    wcInfo: TXDataWebClient;
    qInfo: TXDataWebDataSet;
    dsInfo: TDataSource;
    btnFirst: TSpeedButton;
    btnPrior: TSpeedButton;
    ePages: TEdit;
    btnNext: TSpeedButton;
    btnLast: TSpeedButton;
    MessageDlg: TMessageDlg;
    qInfoDescription: TStringField;
    qInfoYearNo: TIntegerField;
    qInfoMonthNo: TIntegerField;
    qInfoRevenueTotal: TFloatField;
    qInfoSurplusTotal: TFloatField;
    qInfoCostCode: TIntegerField;
    procedure btnFirstClick(Sender: TObject);
    procedure btnPriorClick(Sender: TObject);
    procedure btnNextClick(Sender: TObject);
    procedure btnLastClick(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
    procedure qInfoAfterOpen(DataSet: TDataSet);
    procedure btnCloseClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure btnInsertClick(Sender: TObject);
    procedure btnEditClick(Sender: TObject);
  private
    { Private declarations }
    iPageNo,
    iPageCount : Integer;
    procedure StartLoadData;
    procedure UpdatePageButtons;
    procedure LoadData;
    procedure UpdateNavButtons;
    procedure UpdateButtons;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmBudgetsOwnFleet: TfrmBudgetsOwnFleet;

implementation

{$R *.dfm}

uses
  stfmssystem.connection,
  assets.settings.budgetownfleet.maintenance;

procedure TfrmBudgetsOwnFleet.btnCloseClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmBudgetsOwnFleet.btnEditClick(Sender: TObject);
  var
    LFrm : TfrmOwnFleetBudgetMaintenance;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if bSave then
          StartLoadData;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmOwnFleetBudgetMaintenance) do
      begin
        bInsert := False;
        iYear := qInfo.FieldByName('yearno').asInteger;
        iMonth := qInfo.FieldByName('monthno').asInteger;
        iCost := qInfo.FieldByName('costcode').asInteger;
      end;
  end;
begin
  LFrm := TfrmOwnFleetBudgetMaintenance.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmBudgetsOwnFleet.btnFirstClick(Sender: TObject);
begin
  iPageNo := 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmBudgetsOwnFleet.btnInsertClick(Sender: TObject);
  var
    LFrm : TfrmOwnFleetBudgetMaintenance;

  procedure AfterShowModal(AValue: TModalResult);
  begin
    with LFrm do
      begin
        if bSave then
          StartLoadData;
      end;
  end;

  procedure AfterCreate(AForm : TObject);
  begin
    with (AForm as TfrmOwnFleetBudgetMaintenance) do
      begin
        bInsert := True;
        iYear := 0;
        iMonth := 0;
        iCost := 0;
      end;
  end;
begin
  LFrm := TfrmOwnFleetBudgetMaintenance.CreateNew( @AfterCreate );

  // LFrm als Pop-Up festlegen
  LFrm.Popup := true;

  // Transparenz definieren
  LFrm.PopupOpacity := 0.2;

  LFrm.ShowModal(@AfterShowModal);
end;

procedure TfrmBudgetsOwnFleet.btnLastClick(Sender: TObject);
begin
  iPageNo := iPageCount;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmBudgetsOwnFleet.btnNextClick(Sender: TObject);
begin
  iPageNo := iPageNo + 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmBudgetsOwnFleet.btnPriorClick(Sender: TObject);
begin
  iPageNo := iPageNo - 1;
  UpdatePageButtons;
  LoadData;
end;

procedure TfrmBudgetsOwnFleet.LoadData;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      qInfo.Close;
      qInfo.SetJsonData(TJSArray(TJSObject(Response.Result)['value']));
      qInfo.Open;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  wcInfo.RawInvoke('IassestsService.GetOwnFleetBudget',
                       [iPageNo],@OnResultSummary);
end;

procedure TfrmBudgetsOwnFleet.qInfoAfterOpen(DataSet: TDataSet);
begin
  daBudget.Active := True;

  TFloatField(qInfo.FieldByName('RevenueTotal')).DisplayFormat := '#,##0.00';
  TFloatField(qInfo.FieldByName('SurplusTotal')).DisplayFormat := '#,##0.00';
  UpdateNavButtons;
end;

procedure TfrmBudgetsOwnFleet.StartLoadData;
  procedure OnResultSummary(Response : TXDataClientResponse);
  begin
    try
      iPageCount := JS.ToInteger(JS.ToObject(Response.Result)['value']);
      iPageNo := 1;

      UpdatePageButtons;

      LoadData;
    except
      On E:Exception do
        MessageDlg.ShowDialog(E.Message, WEBLib.Dialogs.mtError, [mbOk]);
    end;
  end;
begin
  wcInfo.RawInvoke('IassestsService.GetOwnFleetBudgetPageCount', [], @OnResultSummary);
end;

procedure TfrmBudgetsOwnFleet.UpdateButtons;
begin
  ePages.Text := IntToStr(iPageNo) + ' of ' + IntToStr(iPageCount);
  if iPageNo > 1 then
    begin
      btnFirst.Enabled := True;
      btnPrior.Enabled := True;
    end
  else
    begin
      btnFirst.Enabled := False;
      btnPrior.Enabled := False;
    end;
  if (iPageCount > 1) and (iPageNo < iPageCount) then
    begin
      btnNext.Enabled := True;
      btnLast.Enabled := True;
    end
  else
    begin
      btnNext.Enabled := False;
      btnLast.Enabled := False;
    end;
end;

procedure TfrmBudgetsOwnFleet.UpdateNavButtons;
begin
  if qInfo.IsEmpty then
    begin
      btnInsert.Enabled := True;
      btnEdit.Enabled := False;
      btnDelete.Enabled := False;
    end
  else
    begin
      btnInsert.Enabled := True;
      btnEdit.Enabled := True;
      btnDelete.Enabled := True;
    end;
end;

procedure TfrmBudgetsOwnFleet.UpdatePageButtons;
begin

end;

procedure TfrmBudgetsOwnFleet.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Action := caFree;
end;

procedure TfrmBudgetsOwnFleet.WebFormShow(Sender: TObject);
begin
  StartLoadData;
end;

procedure TfrmBudgetsOwnFleet.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  scTop := TScrollBox.Create(Self);
  btnInsert := TSpeedButton.Create(Self);
  btnEdit := TSpeedButton.Create(Self);
  btnDelete := TSpeedButton.Create(Self);
  MessageDlg := TMessageDlg.Create(Self);
  sbBottom := TScrollBox.Create(Self);
  btnClose := TSpeedButton.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnPrior := TSpeedButton.Create(Self);
  ePages := TEdit.Create(Self);
  btnNext := TSpeedButton.Create(Self);
  btnLast := TSpeedButton.Create(Self);
  gBudget := TTMSFNCGrid.Create(Self);
  daBudget := TTMSFNCGridDatabaseAdapter.Create(Self);
  wcInfo := TXDataWebClient.Create(Self);
  qInfo := TXDataWebDataSet.Create(Self);
  qInfoDescription := TStringField.Create(Self);
  qInfoYearNo := TIntegerField.Create(Self);
  qInfoMonthNo := TIntegerField.Create(Self);
  qInfoRevenueTotal := TFloatField.Create(Self);
  qInfoSurplusTotal := TFloatField.Create(Self);
  qInfoCostCode := TIntegerField.Create(Self);
  dsInfo := TDataSource.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  scTop.BeforeLoadDFMValues;
  btnInsert.BeforeLoadDFMValues;
  btnEdit.BeforeLoadDFMValues;
  btnDelete.BeforeLoadDFMValues;
  MessageDlg.BeforeLoadDFMValues;
  sbBottom.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnPrior.BeforeLoadDFMValues;
  ePages.BeforeLoadDFMValues;
  btnNext.BeforeLoadDFMValues;
  btnLast.BeforeLoadDFMValues;
  gBudget.BeforeLoadDFMValues;
  daBudget.BeforeLoadDFMValues;
  wcInfo.BeforeLoadDFMValues;
  qInfo.BeforeLoadDFMValues;
  qInfoDescription.BeforeLoadDFMValues;
  qInfoYearNo.BeforeLoadDFMValues;
  qInfoMonthNo.BeforeLoadDFMValues;
  qInfoRevenueTotal.BeforeLoadDFMValues;
  qInfoSurplusTotal.BeforeLoadDFMValues;
  qInfoCostCode.BeforeLoadDFMValues;
  dsInfo.BeforeLoadDFMValues;
  try
    Name := 'frmBudgetsOwnFleet';
    Width := 640;
    Height := 480;
    Caption := 'Budget';
    Color := clSilver;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 640;
    WebLabel1.Height := 33;
    WebLabel1.Align := alTop;
    WebLabel1.Alignment := taCenter;
    WebLabel1.AutoSize := False;
    WebLabel1.Caption := 'Own Fleet - Budgets';
    WebLabel1.Color := clSilver;
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -16;
    WebLabel1.Font.Name := 'Segoe UI';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.Layout := tlCenter;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    scTop.SetParentComponent(Self);
    scTop.Name := 'scTop';
    scTop.AlignWithMargins := True;
    scTop.Left := 3;
    scTop.Top := 36;
    scTop.Width := 634;
    scTop.Height := 69;
    scTop.Align := alTop;
    scTop.AutoScroll := True;
    scTop.BorderStyle := bsSingle;
    scTop.Color := clSilver;
    btnInsert.SetParentComponent(scTop);
    btnInsert.Name := 'btnInsert';
    btnInsert.Left := 3;
    btnInsert.Top := 3;
    btnInsert.Width := 100;
    btnInsert.Height := 40;
    btnInsert.Caption := 'Insert';
    btnInsert.Color := clNone;
    btnInsert.Enabled := False;
    btnInsert.Font.Charset := DEFAULT_CHARSET;
    btnInsert.Font.Color := clWindowText;
    btnInsert.Font.Height := -12;
    btnInsert.Font.Name := 'Segoe UI';
    btnInsert.Font.Style := [fsBold];
    btnInsert.HeightPercent := 100.000000000000000000;
    btnInsert.ParentFont := False;
    btnInsert.TabOrder := 0;
    btnInsert.WidthPercent := 100.000000000000000000;
    SetEvent(btnInsert, Self, 'OnClick', 'btnInsertClick');
    btnEdit.SetParentComponent(scTop);
    btnEdit.Name := 'btnEdit';
    btnEdit.Left := 109;
    btnEdit.Top := 3;
    btnEdit.Width := 100;
    btnEdit.Height := 40;
    btnEdit.Caption := 'Edit';
    btnEdit.Color := clNone;
    btnEdit.Enabled := False;
    btnEdit.Font.Charset := DEFAULT_CHARSET;
    btnEdit.Font.Color := clWindowText;
    btnEdit.Font.Height := -12;
    btnEdit.Font.Name := 'Segoe UI';
    btnEdit.Font.Style := [fsBold];
    btnEdit.HeightPercent := 100.000000000000000000;
    btnEdit.ParentFont := False;
    btnEdit.TabOrder := 1;
    btnEdit.WidthPercent := 100.000000000000000000;
    SetEvent(btnEdit, Self, 'OnClick', 'btnEditClick');
    btnDelete.SetParentComponent(scTop);
    btnDelete.Name := 'btnDelete';
    btnDelete.Left := 215;
    btnDelete.Top := 3;
    btnDelete.Width := 100;
    btnDelete.Height := 40;
    btnDelete.Caption := 'Delete';
    btnDelete.Color := clNone;
    btnDelete.Enabled := False;
    btnDelete.Font.Charset := DEFAULT_CHARSET;
    btnDelete.Font.Color := clWindowText;
    btnDelete.Font.Height := -12;
    btnDelete.Font.Name := 'Segoe UI';
    btnDelete.Font.Style := [fsBold];
    btnDelete.HeightPercent := 100.000000000000000000;
    btnDelete.ParentFont := False;
    btnDelete.TabOrder := 2;
    btnDelete.WidthPercent := 100.000000000000000000;
    MessageDlg.SetParentComponent(scTop);
    MessageDlg.Name := 'MessageDlg';
    MessageDlg.Left := 368;
    MessageDlg.Top := 32;
    MessageDlg.Width := 24;
    MessageDlg.Height := 24;
    MessageDlg.Buttons := [];
    MessageDlg.Opacity := 0.200000000000000000;
    sbBottom.SetParentComponent(Self);
    sbBottom.Name := 'sbBottom';
    sbBottom.AlignWithMargins := True;
    sbBottom.Left := 3;
    sbBottom.Top := 408;
    sbBottom.Width := 634;
    sbBottom.Height := 69;
    sbBottom.Align := alBottom;
    sbBottom.AutoScroll := True;
    sbBottom.BorderStyle := bsSingle;
    sbBottom.ChildOrder := 1;
    sbBottom.Color := clSilver;
    btnClose.SetParentComponent(sbBottom);
    btnClose.Name := 'btnClose';
    btnClose.Left := 512;
    btnClose.Top := 3;
    btnClose.Width := 100;
    btnClose.Height := 40;
    btnClose.Anchors := [akTop,akRight];
    btnClose.Caption := 'Close';
    btnClose.Color := clCrimson;
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWindowText;
    btnClose.Font.Height := -12;
    btnClose.Font.Name := 'Segoe UI';
    btnClose.Font.Style := [fsBold];
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.TabOrder := 0;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnFirst.SetParentComponent(sbBottom);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 13;
    btnFirst.Top := 5;
    btnFirst.Width := 24;
    btnFirst.Height := 22;
    btnFirst.Caption := '<<';
    btnFirst.Color := clNone;
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.TabOrder := 1;
    btnFirst.WidthPercent := 100.000000000000000000;
    SetEvent(btnFirst, Self, 'OnClick', 'btnFirstClick');
    btnPrior.SetParentComponent(sbBottom);
    btnPrior.Name := 'btnPrior';
    btnPrior.Left := 36;
    btnPrior.Top := 5;
    btnPrior.Width := 24;
    btnPrior.Height := 22;
    btnPrior.Caption := '<';
    btnPrior.Color := clNone;
    btnPrior.HeightPercent := 100.000000000000000000;
    btnPrior.TabOrder := 2;
    btnPrior.WidthPercent := 100.000000000000000000;
    SetEvent(btnPrior, Self, 'OnClick', 'btnPriorClick');
    ePages.SetParentComponent(sbBottom);
    ePages.Name := 'ePages';
    ePages.Left := 60;
    ePages.Top := 5;
    ePages.Width := 52;
    ePages.Height := 22;
    ePages.Alignment := taCenter;
    ePages.ChildOrder := 4;
    ePages.HeightPercent := 100.000000000000000000;
    ePages.ReadOnly := True;
    ePages.Text := '1 of 1';
    ePages.WidthPercent := 100.000000000000000000;
    btnNext.SetParentComponent(sbBottom);
    btnNext.Name := 'btnNext';
    btnNext.Left := 112;
    btnNext.Top := 5;
    btnNext.Width := 24;
    btnNext.Height := 22;
    btnNext.Caption := '>';
    btnNext.Color := clNone;
    btnNext.HeightPercent := 100.000000000000000000;
    btnNext.TabOrder := 4;
    btnNext.WidthPercent := 100.000000000000000000;
    SetEvent(btnNext, Self, 'OnClick', 'btnNextClick');
    btnLast.SetParentComponent(sbBottom);
    btnLast.Name := 'btnLast';
    btnLast.Left := 135;
    btnLast.Top := 5;
    btnLast.Width := 24;
    btnLast.Height := 22;
    btnLast.Caption := '>>';
    btnLast.Color := clNone;
    btnLast.HeightPercent := 100.000000000000000000;
    btnLast.TabOrder := 5;
    btnLast.WidthPercent := 100.000000000000000000;
    SetEvent(btnLast, Self, 'OnClick', 'btnLastClick');
    gBudget.SetParentComponent(Self);
    gBudget.Name := 'gBudget';
    gBudget.AlignWithMargins := True;
    gBudget.Left := 3;
    gBudget.Top := 111;
    gBudget.Width := 634;
    gBudget.Height := 291;
    gBudget.Align := alClient;
    gBudget.ParentDoubleBuffered := False;
    gBudget.DoubleBuffered := True;
    gBudget.TabOrder := 2;
    gBudget.DefaultRowHeight := 40.000000000000000000;
    gBudget.FixedColumns := 0;
    gBudget.ColumnCount := 6;
    gBudget.Options.Bands.Enabled := True;
    gBudget.Options.Editing.CalcFormat := '%g';
    gBudget.Options.Grouping.CalcFormat := '%g';
    gBudget.Options.Grouping.GroupCountFormat := '(%d)';
    gBudget.Options.IO.XMLEncoding := 'ISO-8859-1';
    gBudget.Options.Mouse.ClickMargin := 0;
    gBudget.Options.Mouse.ColumnSizeMargin := 6;
    gBudget.Options.Mouse.RowSizeMargin := 6;
    gBudget.Adapter := daBudget;
    gBudget.Columns.Clear;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 150.000000000000000000;
    end;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 75.000000000000000000;
    end;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaCenter;
      ID := '';
      Width := 75.000000000000000000;
    end;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 100.000000000000000000;
    end;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := 4539717;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := 8026746;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      HorzAlignment := gtaTrailing;
      ID := '';
      Width := 90.000000000000000000;
    end;
    with gBudget.Columns.Add do
    begin
      BorderWidth := 1;
      FixedFont.Charset := DEFAULT_CHARSET;
      FixedFont.Color := clWindowText;
      FixedFont.Height := -11;
      FixedFont.Name := 'Segoe UI';
      FixedFont.Style := [fsBold];
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clWindowText;
      Font.Height := -11;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      ID := '';
      Width := 0.000000000000000000;
    end;
    gBudget.DefaultFont.Charset := DEFAULT_CHARSET;
    gBudget.DefaultFont.Color := clWindowText;
    gBudget.DefaultFont.Height := -11;
    gBudget.DefaultFont.Name := 'Segoe UI';
    gBudget.DefaultFont.Style := [];
    gBudget.TopRow := 1;
    gBudget.Appearance.FixedLayout.Fill.Color := 16380654;
    gBudget.Appearance.FixedLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.FixedLayout.Font.Color := 4539717;
    gBudget.Appearance.FixedLayout.Font.Height := -13;
    gBudget.Appearance.FixedLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.FixedLayout.Font.Style := [fsBold];
    gBudget.Appearance.NormalLayout.Fill.Color := 16578806;
    gBudget.Appearance.NormalLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.NormalLayout.Font.Color := 8026746;
    gBudget.Appearance.NormalLayout.Font.Height := -11;
    gBudget.Appearance.NormalLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.NormalLayout.Font.Style := [];
    gBudget.Appearance.GroupLayout.Fill.Color := 12817262;
    gBudget.Appearance.GroupLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.GroupLayout.Font.Color := clBlack;
    gBudget.Appearance.GroupLayout.Font.Height := -11;
    gBudget.Appearance.GroupLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.GroupLayout.Font.Style := [];
    gBudget.Appearance.SummaryLayout.Fill.Color := 14009785;
    gBudget.Appearance.SummaryLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.SummaryLayout.Font.Color := clBlack;
    gBudget.Appearance.SummaryLayout.Font.Height := -11;
    gBudget.Appearance.SummaryLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.SummaryLayout.Font.Style := [];
    gBudget.Appearance.SelectedLayout.Fill.Color := 16441019;
    gBudget.Appearance.SelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.SelectedLayout.Font.Color := 4539717;
    gBudget.Appearance.SelectedLayout.Font.Height := -11;
    gBudget.Appearance.SelectedLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.SelectedLayout.Font.Style := [];
    gBudget.Appearance.FocusedLayout.Fill.Color := 16039284;
    gBudget.Appearance.FocusedLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.FocusedLayout.Font.Color := 4539717;
    gBudget.Appearance.FocusedLayout.Font.Height := -11;
    gBudget.Appearance.FocusedLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.FocusedLayout.Font.Style := [];
    gBudget.Appearance.FixedSelectedLayout.Fill.Color := clLightsteelblue;
    gBudget.Appearance.FixedSelectedLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.FixedSelectedLayout.Font.Color := clBlack;
    gBudget.Appearance.FixedSelectedLayout.Font.Height := -11;
    gBudget.Appearance.FixedSelectedLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.FixedSelectedLayout.Font.Style := [];
    gBudget.Appearance.BandLayout.Fill.Color := 16711679;
    gBudget.Appearance.BandLayout.Font.Charset := DEFAULT_CHARSET;
    gBudget.Appearance.BandLayout.Font.Color := 8026746;
    gBudget.Appearance.BandLayout.Font.Height := -11;
    gBudget.Appearance.BandLayout.Font.Name := 'Segoe UI';
    gBudget.Appearance.BandLayout.Font.Style := [];
    gBudget.Appearance.ProgressLayout.Format := '%.0f%%';
    gBudget.LeftCol := 0;
    gBudget.ScrollMode := scmItemScrolling;
    gBudget.GlobalFont.Scale := 1.000000000000000000;
    gBudget.GlobalFont.Style := [];
    gBudget.DesignTimeSampleData := True;
    daBudget.SetParentComponent(Self);
    daBudget.Name := 'daBudget';
    daBudget.Left := 328;
    daBudget.Top := 120;
    daBudget.Width := 26;
    daBudget.Height := 26;
    daBudget.Visible := True;
    daBudget.Grid := gBudget;
    daBudget.DataSource := dsInfo;
    daBudget.Columns.Clear;
    with daBudget.Columns.Add do
    begin
      FieldName := 'Description';
      Header := 'Description';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with daBudget.Columns.Add do
    begin
      FieldName := 'YearNo';
      Header := 'Year';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with daBudget.Columns.Add do
    begin
      FieldName := 'MonthNo';
      Header := 'Month';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with daBudget.Columns.Add do
    begin
      FieldName := 'RevenueTotal';
      Header := 'Revenue';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with daBudget.Columns.Add do
    begin
      FieldName := 'SurplusTotal';
      Header := 'Surplus';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    with daBudget.Columns.Add do
    begin
      FieldName := 'CostCode';
      Header := 'Cost Code';
      CheckFalse := 'False';
      CheckTrue := 'True';
    end;
    wcInfo.SetParentComponent(Self);
    wcInfo.Name := 'wcInfo';
    wcInfo.Connection := dmData.dbConnect;
    wcInfo.Left := 419;
    wcInfo.Top := 239;
    qInfo.SetParentComponent(Self);
    qInfo.Name := 'qInfo';
    qInfo.AfterOpen := qInfoAfterOpen;
    qInfo.Connection := dmData.dbConnect;
    qInfo.Left := 483;
    qInfo.Top := 311;
    qInfoDescription.SetParentComponent(qInfo);
    qInfoDescription.Name := 'qInfoDescription';
    qInfoDescription.FieldName := 'Description';
    qInfoYearNo.SetParentComponent(qInfo);
    qInfoYearNo.Name := 'qInfoYearNo';
    qInfoYearNo.FieldName := 'YearNo';
    qInfoMonthNo.SetParentComponent(qInfo);
    qInfoMonthNo.Name := 'qInfoMonthNo';
    qInfoMonthNo.FieldName := 'MonthNo';
    qInfoRevenueTotal.SetParentComponent(qInfo);
    qInfoRevenueTotal.Name := 'qInfoRevenueTotal';
    qInfoRevenueTotal.FieldName := 'RevenueTotal';
    qInfoSurplusTotal.SetParentComponent(qInfo);
    qInfoSurplusTotal.Name := 'qInfoSurplusTotal';
    qInfoSurplusTotal.FieldName := 'SurplusTotal';
    qInfoCostCode.SetParentComponent(qInfo);
    qInfoCostCode.Name := 'qInfoCostCode';
    qInfoCostCode.FieldName := 'CostCode';
    dsInfo.SetParentComponent(Self);
    dsInfo.Name := 'dsInfo';
    dsInfo.AutoEdit := False;
    dsInfo.DataSet := qInfo;
    dsInfo.Left := 531;
    dsInfo.Top := 287;
  finally
    WebLabel1.AfterLoadDFMValues;
    scTop.AfterLoadDFMValues;
    btnInsert.AfterLoadDFMValues;
    btnEdit.AfterLoadDFMValues;
    btnDelete.AfterLoadDFMValues;
    MessageDlg.AfterLoadDFMValues;
    sbBottom.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnPrior.AfterLoadDFMValues;
    ePages.AfterLoadDFMValues;
    btnNext.AfterLoadDFMValues;
    btnLast.AfterLoadDFMValues;
    gBudget.AfterLoadDFMValues;
    daBudget.AfterLoadDFMValues;
    wcInfo.AfterLoadDFMValues;
    qInfo.AfterLoadDFMValues;
    qInfoDescription.AfterLoadDFMValues;
    qInfoYearNo.AfterLoadDFMValues;
    qInfoMonthNo.AfterLoadDFMValues;
    qInfoRevenueTotal.AfterLoadDFMValues;
    qInfoSurplusTotal.AfterLoadDFMValues;
    qInfoCostCode.AfterLoadDFMValues;
    dsInfo.AfterLoadDFMValues;
  end;
end;

end.
